<template>
  <div v-bind:class="['my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 mt-0 maxw-1750', {
      'px-4': !$vuetify.breakpoint.mdAndUp,
  }]">

      <!-- loader skeleton -->
    <template v-if="loading">
      <v-row no-gutters class="flex-row flex-nowrap">
          <v-skeleton-loader type="avatar" class="mr-4" width="60" />
          <v-skeleton-loader type="heading" class="py-3" width="100%" />
      </v-row>
      <v-card v-bind:class="['mt-4 py-4', {
          'px-2': !$vuetify.breakpoint.mdAndUp,
          'px-4': $vuetify.breakpoint.mdAndUp
      }]">
          <v-skeleton-loader type="text" />
          <v-skeleton-loader class="mt-4" type="paragraph" />
      </v-card>
    </template>

    <template v-else-if="item != null">
      <div class="d-flex flex-row align-center">
          <h3>{{ item.name }}</h3>
          <v-spacer
            class="middle-hr my-2 my-md-0"
            :style="{
              borderColor: $vuetify.theme.currentTheme.primary,
              width: $vuetify.breakpoint.mdAndUp ? 'initial' : '100%'
            }"
          />
          <div
            v-if="$vuetify.breakpoint.mdAndUp"
            class="ki-actions d-flex flex-row flex-nowrap justify-end col-auto px-0"
            :style="{ borderColor: $vuetify.theme.currentTheme.primary }"
          >

            <v-btn
              :key="'shareNewDetailsView'"
              icon
              class="ml-4"
              @mouseover="actionHovered = 'share'"
              @mouseleave="actionHovered = null"
              @click.prevent="$event => share($event, item)"
            >
              <v-icon>mdi-share-variant</v-icon>

              <div :class="['ki-action-name', {
                'right': $t(`views.knowledgeItems.share.title`).length > 11
              }]">
                <v-scroll-y-transition>
                  <p
                    class="text-body mb-0"
                  >{{ $t(`views.knowledgeItems.share.title`) }}</p>
                </v-scroll-y-transition>
              </div>
            </v-btn>
          </div>
          <!-- <v-btn
            width="24"
            height="24"
            class="mr-2"
            icon
            @click.prevent="$event => share($event, item)"
          >
            <v-icon color="primary">mdi-share-variant</v-icon>
          </v-btn> -->
      </div>

      <v-card
          class="mt-4"
      >
        <v-card-text class="body-1 black--text notification-body"
        v-html="parseResolution(item.zinfo_usuariofinal, item.id)">
        </v-card-text>
      </v-card>
      </template>

      <template v-else>
      <h3>{{ $t('views.notificationDetails.detailTitle') }}</h3>
      <v-card class="mt-4">
          <v-card-text class="text-subtitle-2">
          {{ $t('views.notificationDetails.notFound') }}
          </v-card-text>
      </v-card>
    </template>
    <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>
  </div>
</template>

<script>

import { ShareDialog } from '@/components';

export default {
  props: {
    backButton: Boolean,
    item: Object,
    loading: Boolean,
    id: [String, Number],
  },
  data: () => ({
    sharedItem: null,
    sharedDialogPosition: {},
    openDialog: false,
    pathname: null,
  }),
  components: {
    ShareDialog,
  },
  beforeRouteUpdate(to, from, next) {
    if ([from.name, to.name].every((name) => name === 'NewsDetailView')) {
      this.getNewsItem(to.params.id);
    }
    next();
  },
  methods: {
    share(evt, item) {
      console.log('evt', evt);
      evt.preventDefault();

      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;

      const knowledgeUrl = item?.zVisibleInternet === 1 || item?.zVisibleInternet === null ? 'public/news/' : 'news/';
      const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}${knowledgeUrl}${item.id}`;

      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: this.$t('components.share.mobile.noticeItem'),
          url: fullShareUrl,
          formName: item.name,
          type: 'NEWS',
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t('components.share.subjectBody.notice')} ${item.name}`,
          url: fullShareUrl,
          formName: item.name,
          type: 'NEWS',
        };
        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    getNewsItem(id) {
      this.$emit('request', { type: 'detail', args: { id } });
    },
    parseResolution(resolution, KiId) {
      const accessKey = (this.$store.getters['session/storage'] || {}).access_key;
      if (typeof resolution !== 'string' || accessKey == null) {
        return resolution;
      }
      return resolution
        .replace(/<img[^>]*src="([^">]+)"[^>]*>/g, (img, src) => {
          // Si contiene linkexternal="true", no modificar
          if (/\blinkexternal="true"/.test(img)) {
            return img;
          }

          const NUMERIC_REGEXP = /[-]?\d*\.?\d+/g;
          const numbers = src.match(NUMERIC_REGEXP);

          if (!numbers || !numbers[1]) {
            return img;
          }

          const urlImage = `/proxy-rest/knowledge-item/${KiId}/attachment/${numbers[1]}?accessKey=${accessKey}`;

          return img.replace(src, urlImage);
        });
    },
  },
  mounted() {
    this.getNewsItem(this.id);
  },
};
</script>

<style lang="scss" scoped>
  .notification-body {
      overflow-x: auto;
  }
  .middle-hr {
    border-color: inherit;
    border-width: 1px 0;
    border-style: solid;
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }
  .ki-actions {
    position: relative;

    > button {
      width: 55px !important;
      height: 55px !important;
      border-radius: 50%;
      border-color: inherit;
      border-width: 2px;
      border-style: solid;
      background-color: white;

      &:last-child .ki-action-name.right {
        left: 100%;
        display: table;
        transform: translateX(-100%);
      }
    }

    .ki-action-name {
      pointer-events: none;
      position: absolute;
      bottom: -2.3rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>
